import { render } from "./VideoItem.vue?vue&type=template&id=6e75d14c"
import script from "./VideoItem.vue?vue&type=script&lang=js"
export * from "./VideoItem.vue?vue&type=script&lang=js"
script.render = render

export default script